import React from 'react'
import { useState, useEffect } from 'react';
import moment from 'moment/moment';
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_LINK } from '../API_BASE_PATH';
import { Alert, LinearProgress, Snackbar } from '@mui/material';
import { Error, FlightLand, FlightTakeoff, Warning } from '@material-ui/icons';
import { format } from 'date-fns';
import { useSelector } from 'react-redux';


export default function BookNowFlightOneWay(props) {
    console.log("props1", props)
    const [open, setOpen] = React.useState(false);
    const pageParams = useParams();
    const [IsFullLoading, setIsFullLoading] = useState(false);
    const navigate = useNavigate();
    const [ParamData, setParamData] = useState({});
    const [MobileView, setMobileView] = useState(false);

    const [IsAllow, setIsAllow] = useState(false);

    useEffect(() => {
        console.log("props", props)
        setParamData(JSON.parse(window.atob(pageParams.id)));
        if (props?.resultIndex !== null) { goToBookPage() };
    }, [props?.resultIndex]);

    const goToBookPage = () => {
        setIsFullLoading(true);
        let userData = JSON.parse(localStorage.getItem('LoginUserDetails'));
        let request_id = sessionStorage.getItem('search_request_id')
        let payload_for_create_booking_single_flight = {
            "flight_index": props?.resultIndex,
            "session_id": request_id
        }


        if (localStorage.getItem('islogin') === 'true') {
            axios.post(`${API_BASE_LINK}flight/createBooking`, payload_for_create_booking_single_flight, {
                headers: {
                    'Authorization': userData?.session?.session_token,
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                if (response?.status === 200) {
                    // sessionStorage.setItem('booking_id', response?.data?.booking?.id);
                    let currentTime = new Date();
                    let sendParam = {
                        b: response?.data?.booking?.id,
                        a: ParamData?.AdultCount,
                        c: ParamData?.ChildCount,
                        i: ParamData?.InfantCount,
                        dt: currentTime
                    }
                    console.log('new Date()', new Date())
                    let getString = window.btoa(JSON.stringify(sendParam));
                    // console.log(getString)
                    // console.log(ParamData?.AdultCount)
                    // if(response?.booking?.Segments)
                    navigate("/booking/" + getString);
                    console.log(`${API_BASE_LINK}/flight/createBooking`, response);
                }
            })
                .catch(function (error) {
                    console.log(error);
                    setIsFullLoading(false);
                    alert('--', error.code);
                });
        } else {
            // alert("Without login we can't proceed. Loging please");
            setOpen(true);
            setIsFullLoading(false);
            // navigate('/login')
        }



    }

    return (
        <div className='flight_holder_wrap'>
            {open && <div onClick={() => setOpen(false)} className='bg-dark w-100 vh-100 position-fixed top-0 left-0 ' style={{ zIndex: '99', opacity: "0.90" }}></div>}
            <Snackbar
                open={open}
                autoHideDuration={600}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                style={{ zIndex: 99999999, top: "40%", }}
            // onClose={handleClose}
            // message="Note archived"

            >
                <div className='bg-dark bg-gradient p-3 rounded-1 shadow-lg text-center  '>
                    <h3>Login alert !</h3>
                    <p>  Without a login, we can't proceed. Logging please!</p>
                    <Link to={'/login'} className='btn  cust_btn_one'><b>Login</b></Link>
                </div>
            </Snackbar>
            {IsFullLoading &&
                <div className="fullLoader d-flex align-items-center justify-content-center">
                    <div className='text-center col-md-3'>
                        <p>Please wait...</p>
                        <LinearProgress color="secondary" />
                    </div>
                </div>
            }

        </div>
    )
}
